import React, {useState} from 'react';
import Confirmation from "../../js/confirmation";

const LocationSelector = props => {
  const [currentlySelected, setCurrentlySelected] = useState(props.selectedEpicId);

  const updateSelected = async (selected) => {
    const newEpicId = selected.currentTarget.dataset.epicid;
    setCurrentlySelected(newEpicId);
    await Confirmation.updateLocation(newEpicId, selected.currentTarget.dataset.name, selected.currentTarget.dataset.address, props.providerAllSlots);
  }

  return (
    <div className="location-select-box">
      <button className="close-bar" type="button">
        <svg
          className="close-icon"
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000"
        >
          <path d="M0 0h24v24H0V0z" fill="none"/>
          <path
            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"/>
        </svg>
        {props.field_close_list_label}
      </button>
      <div className="location-list dropdown-content">
        {props.locations.map((location) => {
          return <button key={location.department.id} className="location-box" type="button" data-epicid={`${location.department.id}`} data-name={`${location.department.name}`} data-address={`${location.department.address.line1}, ${location.department.address.city}, ${location.department.address.state} ${location.department.address.zipCode}`} onClick={updateSelected}>
              { currentlySelected === location.department.id &&
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="selected-icon icon">
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29 5.7 12.7a.996.996 0 1 1 1.41-1.41L10 14.17l6.88-6.88a.996.996 0 1 1 1.41 1.41l-7.59 7.59a.996.996 0 0 1-1.41 0z" fill="#248473" fillRule="nonzero"/>
                  </g>
                </svg>
              }
              { currentlySelected !== location.department.id &&
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="unselected-icon icon">
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 19c-4.973 0-9-4.027-9-9s4.027-9 9-9 9 4.027 9 9-4.027 9-9 9z" fill="#6B7480" fillRule="nonzero"/>
                  </g>
                </svg>
              }
              <div className="address-group">
                <div className="location-name">{location.department.name}</div>
                <div className="location-address">{location.department.address.line1}, {location.department.address.city}, {location.department.address.state} {location.department.address.zipCode}</div>
              </div>
            </button>
        })}
      </div>
    </div>
  );
};

export default LocationSelector;
